

import { getApiConfig } from '../../config/api.config'
import { Permission } from '@communicare/medications/Config/PermissionConfig';
import { authenticatedFetch } from "../../features/auth/AuthenticatedService";
export interface User {

    id: string;

    familyName?: string | null;

    givenNames?: string | null;

    username?: string | null;

    email?: string | null;

    enabled: boolean;

    isSystemContact: boolean;

    authoringSystem?: string | null;

    authoringSystemForeignKey?: string | null;
}

export interface IIdentity {
    user: User,
    permissions: Permission[]
}

const userAccessMap = new Map<string,boolean>()

const cachedAccessToResident = (getAccess:(authoringSystem: string, authoringSystemForeignKey: string)=>Promise<boolean>)=>{
    return async (authoringSystem: string, authoringSystemForeignKey: string,)=>{
        let key = `${authoringSystem}-${authoringSystemForeignKey}`;
        if (!userAccessMap.has(key)) {
            let hasAccess = await getAccess(authoringSystem,authoringSystemForeignKey);
            userAccessMap.set(key,hasAccess);            
        }

        return userAccessMap.get(key)
    };
}

class UsersApiV1 {
    get baseUrl() {
        return getApiConfig().url.authorisation.replace(/\/+$/, "");
    }

    async getCurrentUser() {
        const path = "/api/v1/users/me";
        let url = `${this.baseUrl}${path}`;
        let data = await fetch(url).then(
            res => res.json()
        );

        return data as User;
    }

    async getUserIdentity(): Promise<IIdentity> {
        const userInfoPath = "/api/v1/users/me";
        let userInfoUrl = `${this.baseUrl}${userInfoPath}`;
        let data = await authenticatedFetch(userInfoUrl).then(
            res => res.json()
        );

        const userPermissionUrl = '/api/v1/users/me/permissions';
        let permissionsUrl = `${this.baseUrl}${userPermissionUrl}`;
        let permissions = await authenticatedFetch(permissionsUrl).then(
            res => res.json()
        );
        return {
            user: data as User,
            permissions: permissions as Permission[]
        };
    }

    private async hasAccessToResident(authoringSystem: string, authoringSystemForeignKey: string) {
        const dataAccessPath = `/api/v1/users/me/data-access/Patient/${authoringSystem}/${authoringSystemForeignKey}`;
        let url = `${this.baseUrl}${dataAccessPath}`;
        let data = await authenticatedFetch(url).then(
            res => res.json()
        );
        var isAllowed = data.state == "allowed" ? true : false;
        return isAllowed;
    }

    async doesUserHaveAccessToResident(authoringSystem: string, authoringSystemForeignKey: string) {
        let fetcher = cachedAccessToResident(this.hasAccessToResident.bind(this));
        return fetcher(authoringSystem,authoringSystemForeignKey);
    }
}


const userService = new UsersApiV1();

export { userService };
